import Vue from "vue";
import Vuex from "vuex";
//import createLogger from "vuex/dist/logger";
//import createPersistedState from "vuex-persistedstate";

import churn from "./modules/churn";
import solver from "./modules/solver";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    churn,
    solver,
  },
  strict: debug,
  plugins: [],
});
